const _state = {
  currentRow: null,
  tagsCounter: null,
  hasTickets: null,
}

export const initialState = () => _state

export const state = initialState()
